module.exports = function(app) {
	"use strict";
	app.controller('pages.verify-and-agree', ["$state", "$scope", "session", "sessionData", "$filter", "employerUtility", "coremetrics", function ($state, $scope, session, sessionData, $filter, employerUtility, coremetrics) {
		$scope.employer = sessionData.employerInfo.planAdministrator;
		$scope.sidebar = {
			breadCrumb : {
				primary : {
					title: "Verify & Agree"
				}
			}
		};

		$scope.agree = function() {
			coremetrics.elementTag('AGREE AND CONTINUE PASSWORD', 'EMPLOYERS:HOME PAGE');
			sessionData.tempPasswordAgree = true;
			$state.go('employer-change-password');
		};

		$scope.cancel = function() {
			if (sessionData.tempPassword) {
				session.logoutWithRedirect()
			}
			else {
				$state.go('profile');
			}
		};
	}]);

	return [
		{
			state: "verify-and-agree",
			url: "/verify-and-agree",
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/content-page.html'],
					controller: "pages.verify-and-agree"
				},
				"content@verify-and-agree": {
					templateUrl: 'verify-and-agree.employerTemplate.html/pages/verifyAndAgree/verifyAndAgree'
				}
			}
		}
	];
};

